import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'lex-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    standalone: false
})
export class IconButtonComponent implements OnInit{

  @Input() icon: string = '';
  @Input() type: 'default'|'action' = 'default';
  @Input() disabled: boolean = false;
  @Input() background: 'show'|'none' = 'show'
  @Output() clicked = new EventEmitter();

  public size: string;
  public height: string;

  ngOnInit(): void {
    this.size = this.type === 'default' ? '20px': '14px';
    this.height = this.type === 'default' ? '40px': '30px';
  }
}
